import { type MetaFunction } from '@remix-run/node'
import americancollectors from './americancollectors.png'

export const meta: MetaFunction = () => [
	{ title: 'American Collectors' },
	{
		name: 'description',
		content: 'We offer insurance from American Collectors',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">American Collectors</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img
					src={americancollectors}
					alt="American Collectors"
					className="w-64"
				/>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					American Collectors Insurance specializes in insurance for your
					collectible car.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has awarded the company with a rating of A (Excellent).
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://americancollectors.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://americancollectors.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					1-800-360-2277
					<br />
					<br />
					<a
						href="https://americancollectors.com/filing-a-claim/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://americancollectors.com/filing-a-claim/ (opens in a new tab)
					</a>
				</p>
			</p>
			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					American Collectors Insurance
					<br />
					951 Haddonfield Road, Suite 2A
					<br />
					Cherry Hill, NJ 08002
				</p>
			</section>
		</main>
	)
}
